import { RootState } from 'redux/schemas';

const getSupervisorDashboard = (state: RootState) => state.models.supervisorDashboard;

export const getStorePendingSubmissionsData = (state: RootState) => state.app.supervisorDashboard.pendingSubmissions;

export const getSupervisorCoursesData = (state: RootState) => state.app.supervisorDashboard.courses;

export default getSupervisorDashboard;
